import { Model3d } from "../arrangement3d/Model3d";
import * as Scenes from "oc-threejs/Scenes";
import * as Commons from "oc-commons/Commons";
import { Jaco } from "./Jaco";
import { v3 } from "oc-threejs/short3";

import { Box3, BufferGeometry, Group, Object3D, Vector3 } from "three";

// APP interface with richMetadata
interface IApp {
  checkMMRNotUndefined: (mmr: any) => void;
  modelsHelper: {
    getBoundingBox: (model: any) => Box3;
  };
  richMetadata: {
    findModelMaterialRelation: (key: string) => any;
  };
}
declare const APP: IApp;

export class Model extends Jaco {
  isModel = true;

  // hier kommen die Vorgaben rein, die in  clippingParameters kopiert werden (achtung, nicht referenz gleich setzen!)
  /** @type {?Object} */
  defaultClippingParameters: any = null;

  // clippingParameters werden aufgrund der generischen Natur nicht automatisch persistiert - hierzu Model ableiten
  /** @type {?Object} */
  clippingParameters: any = Commons.cloneDeep(this.defaultClippingParameters);

  clippingFunction: (group: Group, clipObj: Object3D) => void = Scenes.intersect;

  modelMaterialRelation: any;

  clipping: boolean = true; // darüber kann clipping für debugzwecke ausgeschaltet werden

  _update3dCounter: number = 0;

  /** */
  constructor(parent: Jaco | null, modelMaterialRelation: any) {
    super(parent);
    APP.checkMMRNotUndefined(modelMaterialRelation);
    this.modelMaterialRelation = modelMaterialRelation;
  }

  isClipping(): boolean {
    return this.clipping;
  }

  /** */
  toJSON(): Record<string, any> {
    const json = super.toJSON();
    json.Key = this.modelMaterialRelation.Key;
    return json;
  }

  /** */
  fromJSON(json: any): this {
    super.fromJSON(json);
    this.modelMaterialRelation = APP.richMetadata.findModelMaterialRelation(json.Key);
    return this;
  }

  /** */
  update3d() {
    super.update3d();
  }

  createJaco3d(): Model3d {
    return new Model3d(this);
  }

  /** */
  getBoxUnclipped(): Box3 {
    const model = this.getMeta();
    return APP.modelsHelper.getBoundingBox(model);
  }

  /** */
  getSizeUnclipped(): Vector3 {
    return this.getBoxUnclipped().getSize(v3());
  }

  /** */
  getBox(): Box3 {
    const box = this.getBoxUnclipped();
    const clippingGeometry = this.getClippingGeometry();
    if (!clippingGeometry || !this.clipping) {
      return box;
    }
    clippingGeometry.computeBoundingBox();
    if (clippingGeometry.boundingBox) {
      return box.intersect(clippingGeometry.boundingBox);
    }
    return box;
  }

  getMeta(): any {
    return this.modelMaterialRelation;
  }

  get key(): string {
    return this.getMeta().id;
  }

  /**
   * clippingGeometry muß abgeleitet werden, wenn das Object3D zugeschnitten werden soll
   * @returns {?Geometry}
   */
  getClippingGeometry(): BufferGeometry | null | undefined {
    return undefined;
  }

  /** */
  get hasClippingParameters(): boolean {
    return (
      this.clippingParameters != null &&
      !Commons.isEqualEpsilon(this.defaultClippingParameters, this.clippingParameters)
    );
  }

  /** */
  get isClipped(): boolean {
    return this.clipping && this.hasClippingParameters;
  }
}
